// ─── ACTION TYPES ─────────────────────────────────────────────────────────────

export const BACK_ON_AIR_ACTIONS = {
	// Import File
	BOA_IMPORT_REQUEST: 'BOA_IMPORT_REQUEST',
	BOA_IMPORT_SUCCESS: 'BOA_IMPORT_SUCCESS',
	BOA_IMPORT_FAILURE: 'BOA_IMPORT_FAILURE',

	// Get Last Update
	BOA_GET_LAST_UPDATE_REQUEST: 'BOA_GET_LAST_UPDATE_REQUEST',
	BOA_GET_LAST_UPDATE_SUCCESS: 'BOA_GET_LAST_UPDATE_SUCCESS',
	BOA_GET_LAST_UPDATE_FAILURE: 'BOA_GET_LAST_UPDATE_FAILURE',

	// Generate Result
	BOA_GENERATE_REQUEST: 'BOA_GENERATE_REQUEST',
	BOA_GENERATE_SUCCESS: 'BOA_GENERATE_SUCCESS',
	BOA_GENERATE_FAILURE: 'BOA_GENERATE_FAILURE',

	// Helix Get Status
	HELIX_GET_STATUS_REQUEST: 'HELIX_GET_STATUS_REQUEST',
	HELIX_GET_STATUS_SUCCESS: 'HELIX_GET_STATUS_SUCCESS',
	HELIX_GET_STATUS_FAILURE: 'HELIX_GET_STATUS_FAILURE',

	// Helix Fetch Data
	HELIX_FETCH_REQUEST: 'HELIX_FETCH_REQUEST',
	HELIX_FETCH_SUCCESS: 'HELIX_FETCH_SUCCESS',
	HELIX_FETCH_FAILURE: 'HELIX_FETCH_FAILURE',

	// Helix Export Result
	HELIX_EXPORT_REQUEST: 'HELIX_EXPORT_REQUEST',
	HELIX_EXPORT_SUCCESS: 'HELIX_EXPORT_SUCCESS',
	HELIX_EXPORT_FAILURE: 'HELIX_EXPORT_FAILURE',

	// Helix Get Queue
	HELIX_GET_QUEUE_REQUEST: 'HELIX_GET_QUEUE_REQUEST',
	HELIX_GET_QUEUE_SUCCESS: 'HELIX_GET_QUEUE_SUCCESS',
	HELIX_GET_QUEUE_FAILURE: 'HELIX_GET_QUEUE_FAILURE',
};

// ─── ACTION CREATORS ──────────────────────────────────────────────────────────

// Import File
export const boaImportRequest  = ()        => ({ type: BACK_ON_AIR_ACTIONS.BOA_IMPORT_REQUEST });
export const boaImportSuccess  = (payload) => ({ type: BACK_ON_AIR_ACTIONS.BOA_IMPORT_SUCCESS, payload });
export const boaImportFailure  = (error)   => ({ type: BACK_ON_AIR_ACTIONS.BOA_IMPORT_FAILURE, error });

// Get Last Update
export const boaGetLastUpdateRequest = ()        => ({ type: BACK_ON_AIR_ACTIONS.BOA_GET_LAST_UPDATE_REQUEST });
export const boaGetLastUpdateSuccess = (payload) => ({ type: BACK_ON_AIR_ACTIONS.BOA_GET_LAST_UPDATE_SUCCESS, payload });
export const boaGetLastUpdateFailure = (error)   => ({ type: BACK_ON_AIR_ACTIONS.BOA_GET_LAST_UPDATE_FAILURE, error });

// Generate Result
export const boaGenerateRequest = ()        => ({ type: BACK_ON_AIR_ACTIONS.BOA_GENERATE_REQUEST });
export const boaGenerateSuccess = (payload) => ({ type: BACK_ON_AIR_ACTIONS.BOA_GENERATE_SUCCESS, payload });
export const boaGenerateFailure = (error)   => ({ type: BACK_ON_AIR_ACTIONS.BOA_GENERATE_FAILURE, error });

// Helix Get Status
export const helixGetStatusRequest = ()        => ({ type: BACK_ON_AIR_ACTIONS.HELIX_GET_STATUS_REQUEST });
export const helixGetStatusSuccess = (payload) => ({ type: BACK_ON_AIR_ACTIONS.HELIX_GET_STATUS_SUCCESS, payload });
export const helixGetStatusFailure = (error)   => ({ type: BACK_ON_AIR_ACTIONS.HELIX_GET_STATUS_FAILURE, error });

// Helix Fetch Data
export const helixFetchRequest = ()        => ({ type: BACK_ON_AIR_ACTIONS.HELIX_FETCH_REQUEST });
export const helixFetchSuccess = (payload) => ({ type: BACK_ON_AIR_ACTIONS.HELIX_FETCH_SUCCESS, payload });
export const helixFetchFailure = (error)   => ({ type: BACK_ON_AIR_ACTIONS.HELIX_FETCH_FAILURE, error });

// Helix Export Result
export const helixExportRequest = ()        => ({ type: BACK_ON_AIR_ACTIONS.HELIX_EXPORT_REQUEST });
export const helixExportSuccess = (payload) => ({ type: BACK_ON_AIR_ACTIONS.HELIX_EXPORT_SUCCESS, payload });
export const helixExportFailure = (error)   => ({ type: BACK_ON_AIR_ACTIONS.HELIX_EXPORT_FAILURE, error });

// Helix Get Queue
export const helixGetQueueRequest = ()        => ({ type: BACK_ON_AIR_ACTIONS.HELIX_GET_QUEUE_REQUEST });
export const helixGetQueueSuccess = (payload) => ({ type: BACK_ON_AIR_ACTIONS.HELIX_GET_QUEUE_SUCCESS, payload });
export const helixGetQueueFailure = (error)   => ({ type: BACK_ON_AIR_ACTIONS.HELIX_GET_QUEUE_FAILURE, error });